/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SfdcCapabilitySpec { 
    /**
     * Manually generate events when needed
     */
    allow_manual?: boolean;
    /**
     * Send events to SFDC automatically
     */
    automatic?: boolean;
}

